module.exports = __webpack_public_path__ + "img/menu-dots-w.5a6518bf.svg";